import { useInView } from '../../../hooks/useInView';

const offerings = [
  {
    title: 'Seasonal Vegetables',
    description:
      'From our garden beds to your table, fresh, sun-ripened vegetables grown with care and no harmful chemicals. We grow what\'s in season, when it\'s in season.',
    image: '/images/offerings-vegetables.jpg',
    icon: 'ri-seedling-line',
    tag: 'Seasonal',
    tagColor: 'bg-[#2C4A3B]',
  },
  {
    title: 'Farm Fresh Eggs',
    description:
      'Our happy hens roam free-range on open pasture, producing beautiful rich-yolked eggs full of flavor and goodness. Morning glory in every single dozen.',
    image: '/images/offerings-eggs.jpg',
    icon: 'ri-egg-line',
    tag: 'Year-Round',
    tagColor: 'bg-[#C8973A]',
  },
  {
    title: 'Raw Local Honey',
    description:
      'Pure, unfiltered honey from beehives rich in flavor, golden in color, and full of natural goodness that only local bees and wildflowers can provide.',
    image: '/images/offerings-honey.jpg',
    icon: 'ri-flower-line',
    tag: 'Limited',
    tagColor: 'bg-[#C47A5A]',
  },
];

export default function Offerings() {
  const { ref, inView } = useInView(0.1);

  return (
    <section id="offerings" className="w-full bg-[#FAF8F5] py-24 px-8 lg:px-16">
      <div
        ref={ref}
        className={`max-w-6xl mx-auto transition-all duration-1000 ${
          inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="text-center mb-16">
          <p className="text-[#C8973A] text-sm uppercase tracking-[0.3em] mb-3 font-semibold">
            The Harvest
          </p>
          <h2 className="font-serif text-4xl md:text-5xl text-[#3A2A1A] font-bold mb-4 leading-tight">
            From Our Fields<br />to Your Table
          </h2>
          <div className="flex items-center justify-center gap-3 mt-5">
            <span className="block w-12 h-px bg-[#C8973A]" />
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-plant-line text-[#2C4A3B] text-lg" />
            </div>
            <span className="block w-12 h-px bg-[#C8973A]" />
          </div>
          <p
            className="text-[#8B7355] text-base mt-6 max-w-xl mx-auto leading-relaxed"
            style={{ fontFamily: "'Nunito', sans-serif" }}
          >
            We&apos;re a small operation growing in faith. What we grow, we grow with love and we
            pray you&apos;ll be able to share in our harvest very soon.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {offerings.map(({ title, description, image, icon, tag, tagColor }) => (
            <div
              key={title}
              className="group bg-[#FFFEF9] rounded-2xl overflow-hidden border border-[#EDE8DF] transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={image}
                  alt={title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div
                  className={`absolute top-3 right-3 ${tagColor} text-white text-xs font-semibold px-3 py-1 rounded-full`}
                >
                  {tag}
                </div>
              </div>
              <div className="p-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EDF4EB] mb-4">
                  <i className={`${icon} text-[#2C4A3B] text-lg`} />
                </div>
                <h3 className="font-serif text-xl font-bold text-[#3A2A1A] mb-2">{title}</h3>
                <p
                  className="text-[#7B6348] text-sm leading-relaxed mb-4"
                  dangerouslySetInnerHTML={{ __html: description }}
                  style={{ fontFamily: "'Nunito', sans-serif" }}
                />
                <p className="text-[#C8973A] text-sm font-medium italic">
                  Coming Soon &middot; Ask Us About Availability
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
